import axiosIntegration from "../Common/Axios/axiosIntegration";
import API from "../Common/Endpoint/serviceConstrants";

export const callRedeemPointsPostApi = async (payload) => {
  const { data = [] } = await axiosIntegration.post(API.redeemPoint,payload);
  return data;
};
